import AppMailSidebar from './AppMailSidebar';
import { MailProvider } from './Context';
import { ChildContainerProps } from '../../Models/Template';

const AppMailLayout: React.FC<ChildContainerProps> = function({ children }) {
    return (
        <MailProvider>
            <div className="card">
                <div className="row">
                    <div className="col-3">
                        <AppMailSidebar />
                    </div>
                    <div className="col-9">{children}</div>
                </div>
            </div>
        </MailProvider>
    );
};

export default AppMailLayout;
